import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { DpDrawer } from '@/components/blocks/DpDrawer';

interface BenefitProps {
	open: boolean;
	title: string;
	emsName: string;
	onClose: () => void;
}

export const DrawerBenefit: React.FC<BenefitProps> = ({ open, title, emsName, onClose }) => (
	<DpDrawer open={open} title={title} onClose={onClose}>
		<ContentRecommendation
			key={emsName}
			id={emsName}
			properties={{
				emsName,
			}}
		/>
	</DpDrawer>
);
